function fuzzyMatch(pattern, text) {
    let regexPattern = pattern
        .toLowerCase()
        .replace(/\s+/g, '')
        .split('')
        .map(c => c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
        .join('.*');

    let regex = new RegExp(regexPattern, 'i');
    return regex.test(text.toLowerCase());
}

function debounce(func, delay) {
    let timeoutId;

    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

/**
 *
 * @param { {group:string, term:string}[]} selectedFilters
 * @param {string} searchValue
 */
function updateUrl(selectedFilters, searchValue) {
    const urlParams = new URLSearchParams('');
    const objectMap = Object.groupBy(selectedFilters, ({group}) => group)

    Object.entries(objectMap).forEach(([key, value]) => {
        // create url param with comma separated values
        // i.e. market=EMEA,NA
        urlParams.set(key, value.reduce((accumulator, currentValue, currentIndex) => {
            return `${accumulator}${currentIndex === 0 ? "" : ","}${currentValue.term}`
        }, ''))
    })
    if (searchValue.length > 0) {
        urlParams.set("search", searchValue)
    }
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`)
}

/**
 *
 * @param {URLSearchParams} queryParams
 */
function loadFiltersFromUrl(queryParams) {
    queryParams.forEach((value, key, parent) => {
        if (key === 'search') {
            $(".search-by-name").val(value)
            return
        }
        value.split(',').forEach(term => {
            $(".filter-clauses").append(`<span class="filter-clause-or" data-filter-group="${key}" data-filter-term="${term}">${term}</span>`)
            const labelElement = $(`label[data-filter-term='${term}']`)
            labelElement.addClass("active")
            const input = labelElement.prev('input')
            input.prop('checked', true)
        })
    })
    if ($(".search-by-name").val().length > 0) {
        $(".clear-search-by-name").show()
    }
    updateClauses()
}

/**
 * @param { {group:string, term:string}[]} selectedFilters
 */
function updateFilterCountRelatedToGroup(selectedFilters) {
    // Clear bold effect in mobile and counters
    $(".filter-title-caption").removeClass('selected')
    $("[data-counter]").text('')

    const groupByGroupName = Object.groupBy(selectedFilters, ({group}) => group)
    const groupToFilterSize = Object.entries(groupByGroupName).map(([groupName, termArray]) => {
        return {group: groupName, size: termArray.length}
    })

    groupToFilterSize.forEach(el => {
        if (el.size > 0) {
            const counter = $(`span[data-counter='${el.group}']`)
            counter.text(`(${el.size})`)
            counter.addClass('selected')
            counter.prev().addClass('selected')
        }
    })
}

function updateClauses() {
    let clauses_and = [];
    let clauses_dict = {};
    let available_subjects = {};
    let visible_products = 0
    const searchValue = $(".search-by-name").val().toLowerCase()

    // make list of chosen simple list filters
    // they will be treated as AND filters
    // available_subjects is used to disable impossible filters
    $(".filter-clauses .filter-clause-and").map(function (i, e) {
        let clause = $(e);
        let term = clause.data("filter-term");

        clauses_and.push(term);
        available_subjects[term] = true;
    });

    // make dict of filters chosen in both dropdows
    // they will be treated as OR filters
    // dropdown filters are not disabled or hidden even if impossible
    $(".filter-clauses .filter-clause-or").each(function (i, e) {
        let clause = $(e);
        let term = clause.data("filter-term");
        let group = clause.data("filter-group")

        if (group in clauses_dict)
            clauses_dict[group].push(term);
        else
            clauses_dict[group] = [term];

        // this is to ensure that selected filters will stay visible
        // even if there's no product that matches them
        available_subjects[term] = true;
    });

    // hide/show filtered products
    $(".product-item").each(function (i, e) {
        let product = $(e);
        let data = product.data("filter-subjects");

        if (!data)
            return;

        let subjects = data.split(",");
        // SF - simple list filter; DFA, DFB - dropdown filters from different dropdown
        // SF and SF and (DFA or DFA) and (DFB or DFB)
        let show = clauses_and.every(i => subjects.includes(i));

        $.each(clauses_dict, function (i, clauses_or) {
            $(clauses_or).each(function (i, e) {
                available_subjects[e] = true;
            });

            if (clauses_or.length)
                show = show && clauses_or.some(i => subjects.includes(i));
        });

        // Get the text contents for given product
        let textsRelatedToProduct = product
            .find('*')
            .contents()
            .filter(function () {
                return this.nodeType === 3;
            })
            .map(function () {
                return this.nodeValue.trim();
            }).get()
            .filter(el => el.length > 0 && el !== "Datasheet");

        // Filter related to search bar
        show = show &&
            (data.toLowerCase().includes(searchValue) || textsRelatedToProduct.some(el => fuzzyMatch(searchValue, el)))


        if (show) {
            $(subjects).each(function (i, e) {
                available_subjects[e] = true;
            });
            product.show();
            visible_products += 1;
        } else {
            product.hide();
        }
    });

    // show 'no results' message
    if (visible_products != 0) {
        $('#products-no-results').hide();
    } else {
        $('#products-no-results').show();
    }

    // disable simple list filters;
    $('.filter-toggle-and').each(function (i, e) {
        let filter = $(e);
        let term = filter.data("filter-term");

        if (available_subjects[term]) {
            filter.removeClass('disabled');
        } else {
            filter.addClass('disabled');
        }
    });

    const selectedFilters = $(".filter-clauses > span").map(function () {
        return {
            group: $(this).attr('data-filter-group'),
            term: $(this).attr('data-filter-term')
        }
    }).get()

    updateUrl(selectedFilters, searchValue)
    updateFilterCountRelatedToGroup(selectedFilters)
}

$(function () {
    // click on simple list filter
    // OLD IMPLEMENTATION currently unused
    $(".filter-toggle-and").click(function (event) {
        let button = $(event.target);

        if (button.hasClass('disabled'))
            return;

        let term = button.data("filter-term");
        let title = button.text();
        let clauses = $(".filter-clauses");

        button.toggleClass("active");
        if (button.hasClass("active")) {
            clauses.append(`<span class="filter-clause-and" data-filter-term="${term}">${title}</span>`);
        } else {
            clauses.find(`[data-filter-term="${term}"]`).remove();
        }

        updateClauses();
    });

    // click on dropdown filter
    $(".filter-toggle-or").click(function (event) {
        let button = $(event.target);
        let term = button.data("filter-term");
        let title = button.text();
        let group = button.closest("[data-filter-group]").data("filter-group");
        let clauses = $(".filter-clauses");

        button.toggleClass("active");
        if (button.hasClass("active")) {
            clauses.append(`<span class="filter-clause-or" data-filter-group="${group}" data-filter-term="${term}">${title}</span>`);
        } else {
            clauses.find(`[data-filter-term="${term}"]`).remove();
        }

        updateClauses();
    });

    function hideOther(dropdown) {
        let other = $('[data-filter-group]').not(dropdown);
        other.removeClass("show");
        other.find('.dropdown-menu').removeClass("show");
        $('.single-clear').hide()
    }

    // show dropdown list
    $('[data-filter-group] .button-tile').on('click', function (event) {
        let dropdown = $(this).closest('[data-filter-group]');

        dropdown.find('.search-field').val('');
        dropdown.find('.dropdown-empty-filters').hide();
        dropdown.find('p').show();

        dropdown.toggleClass("show");
        dropdown.find(".dropdown-menu").toggleClass("show");

        hideOther(dropdown);
        event.stopPropagation();
    });

    // search in dropdowns
    $('.search-field').on('input', function (event) {
        $('.dropdown-empty-filters').hide() // Ensure that No results text is hide when any input is provided
        let input = $(event.target);
        input.next().show()
        let searchTerm = input.val().toLowerCase();
        let filters = input.closest('[data-filter-group]').find('p');
        let visibleFilters = 0;

        if (!searchTerm) {
            filters.show();
            return;
        }

        filters.each(function (i, e) {
            let filter = $(e);
            let filterValue = filter.find('label').data('filter-term').toLowerCase();

            if (filterValue.search(searchTerm) >= 0 || filter.hasClass('active')) {
                filter.show();
                visibleFilters += 1;
            } else {
                filter.hide();
            }
        });

        if (visibleFilters != 0) {
            filters.siblings('.dropdown-empty-filters').hide();
        } else {
            filters.siblings('.dropdown-empty-filters').show();
        }
    });

    // RESET ALL FILTERS
    $(".filter-reset").click(function (event) {
        $(".filter-clauses").empty();
        $('.search-by-name').val('');
        updateClauses();

        $('.filter-toggle-and').each(function (i, e) {
            $(e).removeClass('active');
        });

        $('.filter-toggle-or').each(function (i, e) {
            let filter = $(e);
            filter.siblings().prop('checked', false);
            filter.removeClass('active');
        });
        $('.clear-search-by-name').hide()
    });

    // UNCLICK FILTER TAG
    $(".filter-clauses").on('click', 'span', function (event) {
        let button = $(event.target);
        let term = button.data("filter-term");

        if (button.hasClass('filter-clause-and')) {
            let filter = $('.simple-filters-list').find(`[data-filter-term="${term}"]`);
            filter.removeClass('active');
        } else {
            let filter = $('.product-dropdown-row').find(`[data-filter-term="${term}"]`);
            filter.siblings().prop('checked', false);
            filter.removeClass('active');
        }

        button.remove();
        updateClauses();
    });

    const onSearchInput = debounce(updateClauses, 300)
    // Search by name
    $(".search-by-name").on('input', function (event) {
        onSearchInput()
        const input = $(event.target)
        let clearSearchElement = $('.clear-search-by-name');
        input.val().length > 0 ? clearSearchElement.show() : clearSearchElement.hide()
    })

    $(".clear-search-by-name").on('click', function () {
        $(".search-by-name").val('')
        $(this).hide()
        updateClauses()
    })

    // Reset single category in mobile view
    $(".filter-single-reset").on('click', function (event) {
        const element = $(event.target)
        const clearForGroup = element.attr('data-reset-single')
        const paragraphs = $(`[data-filter-group='${clearForGroup}'] > .dropdown-menu > .dropdown-filters > p`)
        const inputs = paragraphs.find('input')
        const labels = paragraphs.find('label')

        inputs.prop('checked', false)
        labels.removeClass('active')

        $(".filter-clauses > span").each(function () {
            const el = $(this)
            const labelArray = labels.toArray()
            if (labelArray.some(labelElement => labelElement.innerText.toLowerCase().trim() === el.text().toLowerCase().trim())) {
                el.remove()
            }
        })

        updateClauses()
    })

    $(".single-clear").on('click', function (event) {
        const element = $(this)
        const input = element.prev()
        input.val('')
        element.hide()
        let filters = input.closest('[data-filter-group]').find('p');
        filters.show();
        $('.dropdown-empty-filters').hide()
    })

    $(document).on('click', function (event) {
        let dropdown = $(event.target).closest('[data-filter-group]');
        hideOther(dropdown);
    });

    loadFiltersFromUrl(new URLSearchParams(window.location.search))

    // OPEN MOBILE FILTERS
    $('.filter-mobile-toggle').on('click', function () {
        $('.product-dropdown-row').addClass('product-dropdown-row--open');
    });

    // CLOSE MOBILE FILTER OPTIONS LIST
    $('.filters-mobile-chevron-left').on('click', function (e) {
        e.stopPropagation(); // zapobiega wywołaniu otwierania
        $(this).closest('.dropdown-menu').removeClass('show');
    });

    // CLOSE MOBILE FILTERS
    $('.filters-mobile-button').on('click', function () {
        $('.product-dropdown-row').removeClass('product-dropdown-row--open');
        $('.dropdown-menu').removeClass('show');
    });
});


// WEBPACK FOOTER //
// ./js/products-filter.js